const Vest = () => import('@/views/Vest')

export default [
  {
    path: '/vest',
    component: Vest,
    meta: { requireAuth: true, vest: true }
  }
]
